import { Quill } from 'vue-quill-editor'

const BlockEmbed = Quill.import('blots/block/embed')

class YoutubeBlob extends BlockEmbed {
    static create(value) {
        const node = super.create()

        // Responsive container styles (Aspect Ratio 16:9)
        node.style.position = 'relative'
        node.style.paddingBottom = '56.25%'
        node.style.height = '0'
        node.style.overflow = 'hidden'
        node.style.maxWidth = '100%'
        node.style.width = '100%'

        const iframe = document.createElement('iframe')
        iframe.setAttribute('src', value)
        iframe.setAttribute('frameborder', '0')
        iframe.setAttribute('allowfullscreen', true)
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')

        // Make iframe fill the container
        iframe.style.position = 'absolute'
        iframe.style.top = '0'
        iframe.style.left = '0'
        iframe.style.width = '100%'
        iframe.style.height = '100%'

        node.appendChild(iframe)

        return node
    }

    static value(node) {
        const iframe = node.querySelector('iframe')
        return iframe ? iframe.getAttribute('src') : null
    }
}

YoutubeBlob.blotName = 'video'
YoutubeBlob.tagName = 'div'
YoutubeBlob.className = 'ql-video-responsive'

export default YoutubeBlob
